import { defineStore } from "pinia"
import { OurTeamService } from "@/store/services/ourTeam.service.js"
import { storeToRefs } from "pinia"

export const ourTeamStore = defineStore("ourTeam", {
  state: () => {
    return {
      ourTeam: "",
    }
  },
  getters: {
    getOurTeam: (state) => state.ourTeam,
  },
  actions: {
    getOurTeamAction() {
      if (this.ourTeam != "") return this.ourTeam
      EventSys.$emit("ourTeam_loading")
      OurTeamService.list().then(({ data }) => {
        EventSys.$emit("ourTeam_loaded")
        this.ourTeam = data
      })
    },
  },
})
